import { type BrandConfig, getBrandConfig } from './brand'
import { isEdumiamHostname } from './featureFlags'

/**
 * La marque du tunnel d'inscription standard (/information, /financement…) : Edumiam sur
 * inscription.edumiam.com, où walter-learning.com envoie les produits Edumiam ; null ailleurs
 * (Walter Learning ou Walter Santé, selon le chemin).
 */
export function tunnelBrand(hostname?: string): BrandConfig | null {
  // Hors navigateur (rendu des tests), pas de domaine : le tunnel Walter.
  const host = hostname ?? (typeof window === 'undefined' ? '' : window.location.hostname)
  return host && isEdumiamHostname(host) ? getBrandConfig('edumiam') : null
}

/** Le site vers lequel renvoient le logo et « Retour au site » du tunnel. */
export function tunnelSiteUrl(isSante: boolean, hostname?: string): string {
  const edumiam = tunnelBrand(hostname)
  if (edumiam) return edumiam.websiteUrl
  return isSante ? 'https://walter-learning.com/sante' : 'https://walter-learning.com'
}
